import { configureStore } from '@reduxjs/toolkit'
import licenseClassReducer from './licenseSlice'
import partnersReducer from './partnerSlice'

export const store = configureStore({
    reducer: {
        licenseClasses: licenseClassReducer,
        partners: partnersReducer
    },
})

// Check authentication status on store initialization

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch